export const defaultLocale = 'es';

export const locales = ['es', 'en'];